module.exports = __webpack_public_path__ + "static/img/bg_login.ca41598.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg_login.png
// module id = m30q
// module chunks = 192